import { render, staticRenderFns } from "./WallRsvpButtonBlockSettings.vue?vue&type=template&id=63084deb"
import script from "./WallRsvpButtonBlockSettings.vue?vue&type=script&lang=js"
export * from "./WallRsvpButtonBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports